import React, { useEffect, useRef, useState } from "react";
import { Button, Progress } from "antd";
import { useMediaQuery } from "react-responsive";
import ReactPlayer from "react-player";
import styles from "./VideoPlayer.module.css";

type VideoPlayerProps = {
    url: string;
    playerKey: string;
    onVideoEnd: () => void;
};

const VideoPlayer: React.FC<VideoPlayerProps> = ({ url, playerKey, onVideoEnd }) => {
    const isMobile = useMediaQuery({ maxWidth: 550 });
    const playerRefs = useRef<ReactPlayer | null>();
    const [played, setPlayed] = useState<number>(0);
    const [isFinished, setIsFinished] = useState<boolean>(false);

    useEffect(() => {
        playerRefs.current = null;
    }, []);

    useEffect(() => {
        setIsFinished(false);
        setPlayed(0);
    }, [playerKey]);

    const handleVideoEnd = () => {
        setPlayed(1);
        setIsFinished(true);
        onVideoEnd();
    };

    const handleProgress = (playedFraction: number) => {
        setPlayed((prev) => {
            if (isFinished) return prev;
            return playedFraction;
        });
    };

    const handleClick = () => {
        setIsFinished(false);
        const player = playerRefs.current;
        setPlayed(0);
        player?.seekTo(0, "seconds");
        player?.getInternalPlayer()?.playVideo();
    };

    return (
        <>
            <div style={{ marginBottom: 24 }}>
                <ReactPlayer
                    className={styles.player}
                    ref={(el) => (playerRefs.current = el)}
                    key={playerKey}
                    url={`https://www.youtube.com/embed/${url}`}
                    controls={false}
                    width="100%"
                    onEnded={() => handleVideoEnd()}
                    onProgress={({ played }) => handleProgress(played)}
                    config={{
                        youtube: {
                            playerVars: {
                                controls: 0,
                                disablekb: 1,
                                modestbranding: 1,
                                fs: 0,
                                rel: 0,
                                autoplay: 0,
                            },
                        },
                    }}
                />
                <Progress className={styles.progress} strokeWidth={8} strokeLinecap="square" percent={played * 100} showInfo={false} />
                {!isMobile && (
                    <div className="mt-3" style={{ display: "flex", justifyContent: "center" }}>
                        <Button onClick={handleClick}>다시 보기</Button>
                    </div>
                )}
            </div>
        </>
    );
};

export default VideoPlayer;
